var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-card',{key:("$nested-" + _vm.entityId + "-" + _vm.clientId),attrs:{"client":_vm.client,"dismiss":_vm.dismiss,"loading":_vm.loading,"on-submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }